import {
    Directive,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    Renderer2,
    inject
} from "@angular/core";

@Directive({ selector: "[raskRequired]" })
export class RequiredDirective implements OnInit, OnChanges {
    @Input("raskRequired") required?: boolean;

    private readonly hostElement = inject(ElementRef);
    private readonly renderer = inject(Renderer2);

    ngOnChanges() {
        this.setClass();
    }

    ngOnInit(): void {
        if (this.required === false) {
            return;
        }
        this.setClass();
    }

    setClass() {
        if (this.required) {
            this.renderer.addClass(this.hostElement.nativeElement, "required-asterisk");
        } else {
            this.renderer.removeClass(this.hostElement.nativeElement, "required-asterisk");
        }
    }
}
